/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is the binary calculated?`)
};

const es_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula el binario?`)
};

const de_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird der Binärcode berechnet?`)
};

const nl_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt het binair berekend?`)
};

const fr_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment le binaire est-il calculé?`)
};

const it_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come viene calcolato il binario?`)
};

const pt_br2_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o binário é calculado?`)
};

const pt_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é calculado o binário?`)
};

const ja_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイナリはどのように計算されるのですか?`)
};

const zh_tb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二进制是如何计算的?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_faq1_q", locale)
	if (locale === "en") return en_tb_faq1_q(inputs)
	if (locale === "es") return es_tb_faq1_q(inputs)
	if (locale === "de") return de_tb_faq1_q(inputs)
	if (locale === "nl") return nl_tb_faq1_q(inputs)
	if (locale === "fr") return fr_tb_faq1_q(inputs)
	if (locale === "it") return it_tb_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_tb_faq1_q(inputs)
	if (locale === "pt") return pt_tb_faq1_q(inputs)
	if (locale === "ja") return ja_tb_faq1_q(inputs)
	return zh_tb_faq1_q(inputs)
};